import { render, staticRenderFns } from "./ActivityUnit.vue?vue&type=template&id=4dac9f69&scoped=true&"
import script from "./ActivityUnit.vue?vue&type=script&lang=js&"
export * from "./ActivityUnit.vue?vue&type=script&lang=js&"
import style0 from "./ActivityUnit.vue?vue&type=style&index=0&id=4dac9f69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dac9f69",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
